/* Luna Vibration Alarm — product.luna
   ---------------------------------------------------------------------------
   Swiper gallery: track, thumb strip, desktop hover cursor. Ported from
   reformly-005.js (the 30-day-plan 005 hero), with the per-colour gallery
   rebuild removed — Luna is a single-variant product, so the slides Liquid
   renders are the only ones there will ever be.

   The Swiper options are kept verbatim. Each one is there for a reason that
   only shows up on a real touch device, so they are not worth re-deriving.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var root = document.querySelector('[data-luna]');
  if (!root) return;

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  /* -------------------------------------------------------------------------
     PostHog
     -------------------------------------------------------------------------
     Same event shape as the offer pages, so the dashboard tiles work by
     swapping the prefix — see docs/posthog-setup.md. Property names (color,
     depth, question, source, plan) must match what those insights query.

     `luna_` is the PRE-LAUNCH prefix: it collects test traffic from localhost,
     the preview theme and live-domain testing. Bump it to `lunalive_` at
     launch to give the dashboard a clean slate, exactly as ot001live_ and
     ot003live_ did — the two cannot be separated by a filter afterwards.

     Luna has one variant and no colour option, so there is no color_select —
     six of the seven. plan_select fires on the quantity cards, with plan set to
     "1-pack" / "2-pack" / "3-pack", so the plan-breakdown tile works unchanged.
     Read off the root rather than hardcoded: product.luna and
     product.luna-presale both render this section, so a constant here would
     have pooled both pages under one prefix. sections/reformly-luna.liquid
     resolves it from the template suffix. The defaults are the live page's
     values, so a root missing the attributes behaves exactly as before.
     ------------------------------------------------------------------------- */
  var PH_PREFIX = root.getAttribute('data-luna-ph-prefix') || 'luna_';
  var PAGESET = root.getAttribute('data-luna-pageset') || 'LUNA';
  if (window.posthog && window.posthog.register) {
    window.posthog.register({ reformly_pageset: PAGESET });
  }
  function ph(event, props) {
    if (!window.posthog) return;
    var p = props || {};
    p.page_template = PAGESET;
    window.posthog.capture(PH_PREFIX + event, p);
  }

  ph('reformly_plus_page_view', { url: window.location.href });

  var galleryEl = $('[data-luna-gallery]');
  var thumbBtns = $$('[data-luna-thumb]');
  var cursorEl = $('[data-luna-cursor]');
  var isMobile = function () { return window.innerWidth < 641; };

  var swiperConfig = {
    slidesPerView: 1,
    spaceBetween: 24,
    speed: 380,
    loop: true,
    // Swiper 11 loop mode shifts slides around the active one. Reversing before a
    // transition finishes leaves the wrapper needing an instant re-translate —
    // one janky frame. A spare slide either side means the reversal target is
    // already in place and no loopFix has to run mid-gesture.
    loopAdditionalSlides: 1,
    // Swiper blocks sliding while a loop transition runs (loopPreventsSliding
    // defaults to true), so a reverse swipe mid-animation is swallowed and only
    // applied once the first transition ends — which is what reads as a dropped
    // frame. False lets the reversal take over immediately.
    loopPreventsSliding: false,
    grabCursor: false,
    // A few px of slack before a drag is claimed, and a wide touchAngle, so a
    // vertical flick scrolls the page instead of half-dragging the gallery.
    // longSwipesRatio lowers the distance needed to commit, so a short flick lands.
    threshold: 4,
    touchAngle: 40,
    longSwipesRatio: 0.25,
    resistanceRatio: 0.6,
    breakpoints: {
      // No gap on phones: the slides run edge to edge there, so a gap would
      // show as a strip of page between two full-bleed images mid-swipe.
      0: { slidesPerView: 1, spaceBetween: 0 },
      641: { slidesPerView: 1, spaceBetween: 24 }
    }
  };

  var swiper = null;
  var swiperReady = false;

  function updateThumbs(index) {
    thumbBtns.forEach(function (btn, i) { btn.classList.toggle('is-active', i === index); });
    if (swiperReady && thumbBtns[index]) {
      var thumb = thumbBtns[index];
      var container = thumb.parentElement;
      if (container) {
        container.scrollTo({
          left: thumb.offsetLeft - (container.offsetWidth / 2) + (thumb.offsetWidth / 2),
          // A smooth scroll here runs its own animation on top of the swipe and
          // competes with it; while the gallery is moving, jump instead.
          behavior: (swiper && swiper.animating) ? 'auto' : 'smooth'
        });
      }
    }
  }

  function bindThumbClicks() {
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-luna-thumb'), 10);
        if (swiper) swiper.slideToLoop(idx);
      });
    });
  }

  // Only the on-screen active slide's video plays.
  var galleryInView = true;
  function syncGalleryVideos() {
    if (!galleryEl) return;
    var active = (swiper && swiper.slides && swiper.slides[swiper.activeIndex]) ||
      galleryEl.querySelector('.swiper-slide-active');
    galleryEl.querySelectorAll('video').forEach(function (v) {
      if (galleryInView && active && active.contains(v)) {
        v.muted = true;
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () { });
      } else {
        v.pause();
      }
    });
  }

  if (galleryEl && window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      galleryInView = entries[0].isIntersecting;
      syncGalleryVideos();
    }, { threshold: 0.25 }).observe(galleryEl);
  }

  var galleryViewed = {};
  function trackGalleryView(index) {
    if (index === undefined || index === null) return;
    if (galleryViewed[index]) return;
    galleryViewed[index] = true;
    ph('reformly_plus_gallery_view', {
      index: index,
      images_viewed: Object.keys(galleryViewed).length
    });
  }

  function initSwiper() {
    if (!galleryEl || typeof Swiper === 'undefined') return;
    swiper = new Swiper(galleryEl, swiperConfig);
    trackGalleryView(swiper.realIndex);
    swiper.on('slideChange', function () {
      updateThumbs(swiper.realIndex);
      trackGalleryView(swiper.realIndex);
    });
    // play()/pause() decode work stalls the compositor, so keep it off the
    // transition: settle first, then switch which video is running.
    swiper.on('slideChangeTransitionEnd', syncGalleryVideos);
    syncGalleryVideos();
    bindThumbClicks();
  }

  initSwiper();
  setTimeout(function () { swiperReady = true; }, 100);

  /* -------------------------------------------------------------------------
     Quantity tiers
     -------------------------------------------------------------------------
     Every figure is derived from the unit price Liquid rendered, so the cards
     stay correct in any currency. The percentages are the DISPLAY side of the
     automatic discounts configured in Shopify admin — the cart is what applies
     the money. If the two ever disagree, the page is advertising a saving the
     buyer will not get, so they have to be changed together.
     ------------------------------------------------------------------------- */
  var unitPrice = parseInt(root.getAttribute('data-unit-price'), 10) || 0;
  var variantId = root.getAttribute('data-variant-id');
  var tierPct = {
    1: 0,
    2: parseFloat(root.getAttribute('data-tier2-pct')) || 0,
    3: parseFloat(root.getAttribute('data-tier3-pct')) || 0
  };

  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

  /* Shopify has seven money placeholders, not two — a euro market returns the
     comma-separator one. Same table as the offer pages; without it every price
     this rewrites would print the raw placeholder to half of Europe. */
  function moneyParts(cents, decimals, thousands, decimal) {
    var n = Math.abs(cents / 100).toFixed(decimals);
    var parts = n.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var out = decimals > 0 ? whole + decimal + parts[1] : whole;
    return cents < 0 ? '-' + out : out;
  }

  var MONEY_PLACEHOLDERS = {
    amount:                                  [2, ',', '.'],
    amount_no_decimals:                      [0, ',', '.'],
    amount_with_comma_separator:             [2, '.', ','],
    amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_apostrophe_separator:        [2, "'", '.'],
    amount_with_space_separator:             [2, ' ', ','],
    amount_no_decimals_with_space_separator: [0, ' ', ',']
  };

  function money(cents) {
    return moneyFormat
      .replace(/\{\{\s*(\w+)\s*\}\}/g, function (whole, name) {
        var p = MONEY_PLACEHOLDERS[name] || MONEY_PLACEHOLDERS.amount;
        return moneyParts(cents, p[0], p[1], p[2]);
      })
      .replace(/<[^>]*>/g, '');
  }

  // Shopify applies these automatic discounts with allocation_method "each":
  // the percentage comes off a single unit, truncated to whole cents, and that
  // is charged per item. Discounting the pack total instead lands a cent low
  // and the page then disagrees with the cart — 3199 vs the 3200 actually
  // charged at 3 x 3999 less 20%.
  function tierEach(qty) {
    return unitPrice - Math.floor((unitPrice * tierPct[qty]) / 100);
  }

  function tierTotal(qty) {
    return tierEach(qty) * qty;
  }

  var state = { qty: 1 };

  var qtyCards = $$('[data-luna-qty]');
  // Two displays now carry the price: the header row and the Limited deal card
  // below the trust row. Both are written, so they cannot disagree.
  var priceNow = $$('[data-luna-price]');
  var priceCompare = $$('[data-luna-compare]');
  var priceBadge = $('[data-luna-badge]');
  var stickyPrice = $('[data-luna-sticky-price]');
  var stickyTitle = $('[data-luna-sticky-title]');
  var productTitle = stickyTitle ? stickyTitle.textContent.split(' · ')[0] : '';
  var unitCompare = parseInt(root.getAttribute('data-unit-compare'), 10) || 0;

  function renderTier() {
    var total = tierTotal(state.qty);
    // Per alarm, as in the mock (priceNow = packSel.price / packSel.units).
    // Taken from tierEach rather than dividing the total back down, so it is
    // the same figure the cart charges per item.
    var each = tierEach(state.qty);

    qtyCards.forEach(function (card) {
      var on = parseInt(card.getAttribute('data-luna-qty'), 10) === state.qty;
      card.classList.toggle('is-selected', on);
      card.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    priceNow.forEach(function (el) { el.textContent = money(each); });
    // The sticky bar buys the pack, so it shows what will be charged, and names
    // it the way the mock does: "<product> · 2 alarms".
    if (stickyPrice) stickyPrice.textContent = money(total);
    if (stickyTitle) {
      stickyTitle.textContent = productTitle + ' · ' + state.qty +
        (state.qty === 1 ? ' alarm' : ' alarms');
    }

    // Compare-at is a per-alarm figure too, so it is the same at every tier —
    // what moves is the price beside it, and therefore the saving.
    var show = unitCompare > each;
    priceCompare.forEach(function (el) {
      if (show) el.textContent = money(unitCompare);
      el.hidden = !show;
    });
    if (priceBadge) {
      // A percentage, not an amount — the final design shows
      // "SAVE 53%". Rounded the same way Liquid rounds it on first paint, so
      // the badge does not change value the moment a tier is picked.
      if (show) {
        priceBadge.textContent = 'SAVE ' +
          Math.round(((unitCompare - each) / unitCompare) * 100) + '%';
      }
      priceBadge.hidden = !show;
    }
  }

  qtyCards.forEach(function (card) {
    card.addEventListener('click', function () {
      state.qty = parseInt(card.getAttribute('data-luna-qty'), 10) || 1;
      renderTier();
      ph('reformly_plus_plan_select', { plan: state.qty + '-pack', quantity: state.qty });
    });
  });

  renderTier();

  /* -------------------------------------------------------------------------
     Add to cart
     -------------------------------------------------------------------------
     Mirrors reformly-005.js: add, stamp the PostHog id onto the cart so the
     purchase can be attributed, then open the Plus drawer. This template is
     wired to reformly-plus-cart-drawer in theme.liquid, so window.rypCart is
     the API that owns opening — poking its classes directly does nothing.
     ------------------------------------------------------------------------- */
  function openCartDrawer() {
    if (window.rypCart && window.rypCart.open) { window.rypCart.open(); return; }
    if (typeof liquidAjaxCart !== 'undefined' && liquidAjaxCart.cartRequestUpdate) {
      liquidAjaxCart.cartRequestUpdate();
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (document.querySelector('[data-ajax-cart-section]')) {
      document.body.classList.add('js-ajax-cart-open');
    }
  }

  var atcButtons = $$('[data-luna-atc]');

  atcButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var label = btn.querySelector('[data-luna-atc-text]') || btn;
      var original = label.textContent;
      btn.disabled = true;
      label.textContent = 'ADDING…';

      ph('reformly_plus_add_to_cart', {
        source: btn.getAttribute('data-luna-source') || 'main',
        plan: state.qty + '-pack',
        quantity: state.qty,
        variant_id: variantId
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: state.qty }] })
      })
        .then(function (res) { return res.json(); })
        /* Referenced off window: if the helper is ever absent, .then(undefined)
           is a pass-through, where a bare identifier would throw and kill the
           add. Same reason as reformly-005.js. */
        .then(window.rfStampCart)
        .then(function () {
          label.textContent = 'ADDED';
          openCartDrawer();
          setTimeout(function () {
            label.textContent = original;
            btn.disabled = false;
          }, 1200);
        })
        .catch(function () {
          label.textContent = original;
          btn.disabled = false;
        });
    });
  });


  /* Nav cart button. The mock opened its own drawer (sc-camel-on-click
     openCart); this template is wired to reformly-plus-cart-drawer in
     theme.liquid, so it goes through that drawer's API — the same call the
     add-to-cart path uses. */
  var navCart = $('[data-luna-open-cart]');
  if (navCart) {
    navCart.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }


  /* Accordions. The mock renders each body inside an sc-if driven by component
     state (bf0Open…bf6Open, f.open); the transcription keeps those bodies in the
     DOM as [data-luna-panel] and hidden, so the button preceding each one is
     what toggles it. Capture phase, per docs/posthog-setup.md — a bubble-phase
     listener on a button that disables itself never runs. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button');
    if (!btn || !root.contains(btn)) return;
    var panel = btn.parentElement && btn.parentElement.querySelector(':scope > [data-luna-panel]');
    if (!panel) {
      var sib = btn.nextElementSibling;
      if (sib && sib.hasAttribute('data-luna-panel')) panel = sib;
    }
    if (!panel) return;
    var opening = panel.hidden;
    panel.hidden = !opening;
    var chev = btn.querySelector('svg');
    if (chev) chev.style.transform = opening ? 'rotate(180deg)' : '';
    if (opening) {
      var q = (btn.textContent || '').trim().slice(0, 120);
      if (q) ph('reformly_plus_faq_click', { question: q });
    }
  }, true);


  /* -------------------------------------------------------------------------
     Hero FAQ accordion
     -------------------------------------------------------------------------
     Ported from the 005 hero. A height animation rather than a hidden toggle:
     the gallery beside this column is position: sticky, and an instant height
     change makes it jump. Drive 0 <-> scrollHeight, then settle on auto so a
     resize or a late font swap cannot clip the answer. Single-open, as in 005.
     ------------------------------------------------------------------------- */
  (function () {
    var all = $$('[data-luna-faq-item]');
    if (!all.length) return;

    // Single-open is per GROUP, not per page: the hero accordion and the FAQ
    // section lower down are both built from these items, and opening one in
    // the section must not close the one you left open in the hero. Items are
    // grouped by their parent, which is the list each set sits in.
    var groups = [];
    all.forEach(function (it) {
      var g = groups.filter(function (x) { return x.parent === it.parentNode; })[0];
      if (!g) { g = { parent: it.parentNode, items: [] }; groups.push(g); }
      g.items.push(it);
    });

    function closeItem(it) {
      if (!it.classList.contains('is-open')) return;
      var pn = it.querySelector('.luna__faq-panel');
      pn.style.height = pn.scrollHeight + 'px';
      requestAnimationFrame(function () { pn.style.height = '0'; });
      it.classList.remove('is-open');
      var b = it.querySelector('.luna__faq-q');
      if (b) b.setAttribute('aria-expanded', 'false');
    }

    function openItem(it) {
      var pn = it.querySelector('.luna__faq-panel');
      it.classList.add('is-open');
      // Measure once, then write on the next frame — reading scrollHeight after
      // a forced layout costs two layouts before the animation even starts.
      var target = pn.scrollHeight;
      pn.style.height = '0px';
      requestAnimationFrame(function () { pn.style.height = target + 'px'; });
      var b = it.querySelector('.luna__faq-q');
      if (b) b.setAttribute('aria-expanded', 'true');
    }

    groups.forEach(function (group) {
      group.items.forEach(function (it) {
        var pn = it.querySelector('.luna__faq-panel');
        var btn = it.querySelector('.luna__faq-q');
        if (!pn || !btn) return;

        pn.addEventListener('transitionend', function () {
          if (it.classList.contains('is-open')) pn.style.height = 'auto';
        });

        btn.addEventListener('click', function () {
          var willOpen = !it.classList.contains('is-open');
          group.items.forEach(closeItem);
          if (willOpen) {
            openItem(it);
            var lbl = btn.querySelector('span') || btn;
            ph('reformly_plus_faq_click', { question: lbl.textContent.trim() });
          }
        });
      });
    });
  })();

  /* Sticky bar appears once the main ATC has scrolled past. */
  var stickyEl = $('[data-luna-sticky]');
  var mainAtc = $('#atc-main');
  if (stickyEl && mainAtc && window.IntersectionObserver) {
    // Same condition as the 005 bar. `!isIntersecting` alone is also true while
    // the ATC is still BELOW the fold, which showed the bar at the very top of
    // the page; bottom < 0 means it has actually scrolled past.
    new IntersectionObserver(function (entries) {
      // A class, not the hidden attribute: hidden is display:none, which cannot
      // transition, so the bar appeared instantly. The CSS slides it.
      stickyEl.hidden = false;
      stickyEl.classList.toggle('is-visible',
        !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0);
    }, { threshold: 0, rootMargin: '0px 0px -100% 0px' }).observe(mainAtc);
  }

  if (cursorEl && galleryEl) {
    var cursorSvg = cursorEl.querySelector('svg');
    galleryEl.addEventListener('mouseenter', function () {
      if (isMobile()) return;
      cursorEl.classList.add('is-visible');
    });
    galleryEl.addEventListener('mouseleave', function () {
      cursorEl.classList.remove('is-visible');
    });
    galleryEl.addEventListener('mousemove', function (e) {
      if (isMobile()) return;
      if (e.target.closest('video')) { cursorEl.classList.remove('is-visible'); return; }
      cursorEl.classList.add('is-visible');
      var rect = galleryEl.getBoundingClientRect();
      var x = e.clientX - rect.left;
      cursorEl.style.left = e.clientX + 'px';
      cursorEl.style.top = e.clientY + 'px';
      cursorSvg.style.transform = x < rect.width / 2 ? 'scaleX(-1)' : '';
    });
    galleryEl.addEventListener('click', function (e) {
      if (isMobile()) return;
      if (e.target.closest('video')) return;
      if (!swiper) return;
      var rect = galleryEl.getBoundingClientRect();
      if (e.clientX - rect.left >= rect.width / 2) swiper.slideNext();
      else swiper.slidePrev();
    });
  }

  /* ---------------------------------------------------------------------------
     Scroll depth + FAQ
     ---------------------------------------------------------------------------
     Both use CAPTURE-phase listeners on document, for the reasons documented in
     docs/posthog-setup.md: `toggle` does not bubble, and a bubble-phase click
     listener on a button that disables itself synchronously never runs.
     --------------------------------------------------------------------------- */
  (function () {
    var marks = [25, 50, 75, 100];
    var hit = {};
    var ticking = false;

    function measure() {
      ticking = false;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h <= 0) return;
      var pct = Math.round((window.scrollY / h) * 100);
      marks.forEach(function (m) {
        if (pct >= m && !hit[m]) {
          hit[m] = true;
          ph('reformly_plus_scroll_depth', { depth: m });
        }
      });
      if (hit[100]) window.removeEventListener('scroll', onScroll);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(measure);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    if (!root.contains(d)) return;
    var sum = d.querySelector('summary');
    var q = sum ? sum.textContent.trim() : '';
    if (q) ph('reformly_plus_faq_click', { question: q });
  }, true);

  /* The mock's FAQ is button-driven, not <details>, so the accordions are also
     bound directly. Capture phase for the same reason as above. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-luna-faq]') : null;
    if (!btn || !root.contains(btn)) return;
    var q = (btn.textContent || '').trim().slice(0, 120);
    if (q) ph('reformly_plus_faq_click', { question: q });
  }, true);

  /* -------------------------------------------------------------------------
     Announcement rotation
     -------------------------------------------------------------------------
     Three messages, as in the mock (ANN[state.ann % 3]). The swap rides the
     fade animation rather than a timer of its own: annFade holds opacity at 0
     across 92-100%, so changing the text on `animationiteration` lands while
     the span is invisible and can never be seen mid-swap. A separate interval
     would drift out of phase with the animation and flicker.
     ------------------------------------------------------------------------- */
  (function () {
    var el = $('[data-luna-ann]');
    if (!el) return;

    var msgs = ['data-ann-1', 'data-ann-2', 'data-ann-3']
      .map(function (a) { return (el.getAttribute(a) || '').trim(); })
      .filter(Boolean);
    if (msgs.length < 2) return;   // nothing to rotate through

    var i = 0;
    el.addEventListener('animationiteration', function () {
      i = (i + 1) % msgs.length;
      el.textContent = msgs[i];
    });
  })();

  /* -------------------------------------------------------------------------
     Header state
     -------------------------------------------------------------------------
     At the top the header is a full-bleed bar; past 88px of scroll it becomes
     an inset floating card. Threshold and both states come from the mock, which
     keys them off `scrolled: (window.scrollY || 0) > 88`. Everything visual is
     CSS — this only flips the class, on a rAF so it is one write per frame.
     ------------------------------------------------------------------------- */
  (function () {
    var ticking = false;
    function apply() {
      ticking = false;
      root.classList.toggle('is-scrolled', (window.scrollY || window.pageYOffset || 0) > 88);
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    }, { passive: true });
    apply();
  })();

  /* -------------------------------------------------------------------------
     Cart-drawer adds
     -------------------------------------------------------------------------
     The bestsellers quick view and the drawer's own upsell tiles add straight
     through reformly-plus-cart.js, which captures nothing — it is shared by
     twelve templates and cannot know this page's prefix. It announces each add
     on `ryp:cart-add` instead, and this maps it onto the page's own event.

     Reported as add_to_cart with a distinguishing `source`, not a new event, so
     these adds count in the funnel alongside the main and sticky buttons rather
     than being invisible to it.
     ------------------------------------------------------------------------- */
  document.addEventListener('ryp:cart-add', function (e) {
    var d = (e && e.detail) || {};
    ph('reformly_plus_add_to_cart', {
      source: d.source || 'drawer',
      variant_id: d.id || 0
    });
  });

  /* -------------------------------------------------------------------------
     Nav cart button
     -------------------------------------------------------------------------
     The mock's nav is static markup, so its cart icon had no handler at all.
     The drawer this page uses is the Plus one, opened through window.rypCart —
     the same call the ATC makes.
     ------------------------------------------------------------------------- */
  (function () {
    var cartBtn = $('[data-luna-cart-open]');
    if (!cartBtn) return;
    cartBtn.addEventListener('click', function () {
      if (window.rypCart && typeof window.rypCart.open === 'function') {
        window.rypCart.open();
        ph('reformly_plus_cart_open', { source: 'nav' });
      } else {
        // Drawer script absent (or failed) — the cart page is still reachable.
        window.location.href = '/cart';
      }
    });
  })();

  /* -------------------------------------------------------------------------
     Video carousel
     -------------------------------------------------------------------------
     Ported from reformly-005.js. The rail is a native scroller, so the only JS
     is a passive listener sizing the progress bar, plus the play handling.
     No-ops while the markup is disabled in the section.
     ------------------------------------------------------------------------- */
  (function () {
    var rail = $('[data-luna-video-rail]');
    var drag = $('[data-luna-video-drag]');
    if (!rail) return;

    var tick = false;
    function paintBar() {
      tick = false;
      if (!drag) return;
      var visible = rail.clientWidth;
      var total = rail.scrollWidth;
      if (total <= visible) { drag.style.width = '0'; return; }
      drag.style.width = (visible / total * 100) + '%';
      drag.style.transform = 'translateX(' + (rail.scrollLeft / total * visible) + 'px)';
    }

    rail.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(paintBar);
    }, { passive: true });
    window.addEventListener('resize', paintBar, { passive: true });
    paintBar();

    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    rail.querySelectorAll('.luna__video-slide').forEach(function (slide) {
      var playBtn = slide.querySelector('.luna__video-play');
      var video = slide.querySelector('video');
      if (!playBtn || !video) return;

      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        slide.classList.add('is-playing');
        if (isIOS) {
          video.play();
          if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
          else if (video.requestFullscreen) video.requestFullscreen();
        } else {
          video.setAttribute('controls', '');
          video.play();
        }
        // readyState < 3 means it cannot play through yet — show the spinner
        // so the tile does not look like the tap did nothing.
        if (video.readyState < 3) {
          slide.classList.add('is-loading');
          video.addEventListener('canplay', function handler() {
            slide.classList.remove('is-loading');
            video.removeEventListener('canplay', handler);
          });
        }
        ph('reformly_plus_video_play', { label: playBtn.getAttribute('aria-label') || '' });
      });

      video.addEventListener('ended', function () {
        slide.classList.remove('is-playing');
        video.removeAttribute('controls');
      });
    });
  })();

  /* -------------------------------------------------------------------------
     USP fitting
     -------------------------------------------------------------------------
     Ported from the 005 hero. Each USP has to sit on ONE line, and no static
     size can guarantee that: the copy is editable, the webfont swaps in after
     first paint, and iOS text autosizing renders a declared size larger than
     declared. So measure what actually laid out and step a shared size down
     until every row fits.

     The label is clipped by text-overflow, and both scrollWidth and a Range
     report the CLIPPED width — so the natural width has to come from an
     unclipped clone. It keeps the same class inside the same row, so it
     inherits the current --luna-usp-fs and the strong/regular mix.
     ------------------------------------------------------------------------- */
  (function () {
    var wrap = $('.luna__usps');
    if (!wrap) return;
    var rows = $$('.luna__usp', wrap);
    if (!rows.length) return;
    var MIN = 9, STEP = 0.25;

    // The starting size is whatever the stylesheet declares for --luna-usp-fs
    // at the current width — 16px on desktop, 15px on a phone, which is what the
    // design uses there. Reading it back means removing this fitter's own inline
    // value first, since that shadows the sheet.
    function baseFs() {
      var prev = wrap.style.getPropertyValue('--luna-usp-fs');
      wrap.style.removeProperty('--luna-usp-fs');
      var v = parseFloat(getComputedStyle(wrap).getPropertyValue('--luna-usp-fs'));
      if (prev) wrap.style.setProperty('--luna-usp-fs', prev);
      return v || 16;
    }

    function naturalWidth(el) {
      var probe = el.cloneNode(true);
      probe.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;' +
        'white-space:nowrap;width:auto;max-width:none;flex:none;overflow:visible;';
      el.parentNode.appendChild(probe);
      var w = probe.getBoundingClientRect().width;
      probe.parentNode.removeChild(probe);
      return w;
    }

    function fits() {
      var avail = wrap.clientWidth;
      return rows.every(function (row) {
        var text = row.querySelector('.luna__usp-text');
        var icon = row.querySelector('.luna__usp-tick');
        if (!text) return true;
        var iconW = icon ? icon.getBoundingClientRect().width : 0;
        return naturalWidth(text) <= (avail - iconW - 1);   // 1px of rounding slack
      });
    }

    function fitUsps() {
      // A zero-width column means the block is not laid out yet (pre-paint).
      // Measuring then fails every check and drives the size to the floor.
      if (!wrap.clientWidth) return;
      var size = baseFs();
      wrap.style.setProperty('--luna-usp-fs', size + 'px');
      while (size > MIN && !fits()) {
        size -= STEP;
        wrap.style.setProperty('--luna-usp-fs', size + 'px');
      }
    }

    // Now, after layout settles, and once the webfont swaps in — measuring
    // against fallback metrics reports a fit that does not hold afterwards.
    fitUsps();
    requestAnimationFrame(fitUsps);
    window.addEventListener('load', fitUsps);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitUsps);

    var t;
    function refit() { clearTimeout(t); t = setTimeout(fitUsps, 150); }
    window.addEventListener('resize', refit, { passive: true });
    // Catches what resize does not: rotation settling and the column changing
    // width from anything else on the page.
    if (window.ResizeObserver) new ResizeObserver(refit).observe(wrap);
  })();

  /* -------------------------------------------------------------------------
     Headline fitting
     -------------------------------------------------------------------------
     Same approach as the 005 hero USPs: measure what actually rendered and step
     the size down until it fits, rather than guessing with a vw formula. Fitted
     against a LINE COUNT here — these headings are written to sit on two lines,
     and a clamp() cannot know when the third one appears.

     Why measuring is necessary: the copy is editable, the webfont swaps in
     after first paint, and iOS text autosizing renders a declared size larger
     than declared. Nothing is ever clipped — the text only gets smaller, and
     stops at MIN rather than shrinking without limit.
     ------------------------------------------------------------------------- */
  (function () {
    var els = $$('[data-luna-fit-lines]');
    if (!els.length) return;
    // SOFT_MIN is the size the design itself uses on the narrowest layout —
    // both mocks set every section heading to 26px on mobile, so coming down
    // past it is not fitting, it is undersizing. It is a CEILING on the floor
    // rather than the floor itself: where the heading already renders at 26px
    // there would be nothing left to give, so the real floor is also held to
    // 85% of the heading's own size, and never past ABS_MIN.
    var SOFT_MIN = 26;
    var ABS_MIN = 20;
    var STEP = 0.5;

    // The target is the ATTRIBUTE's value — data-luna-fit-lines="2" means two
    // lines. A rendered <br> can only raise it: an author who writes two breaks
    // wants three lines.
    //
    // This used to be derived from the <br> count alone and ignore the value.
    // Both headings carry one break inside .rf-clin-br, which is hidden below
    // 1080px, so under that width the count was 0, the fitter bailed, and the
    // headings wrapped free — three lines on Clinically Studied and four on
    // Backed by Experts. The floor is what keeps that from becoming the old
    // problem of shrinking to nothing: it walks down to MIN and stops, so on a
    // phone it simply rests at 26px and wraps, which is what both mocks do.
    function targetLines(el) {
      var brs = el.querySelectorAll('br');
      var shown = 0;
      for (var i = 0; i < brs.length; i++) {
        if (brs[i].getClientRects().length) shown++;
      }
      var declared = parseInt(el.getAttribute('data-luna-fit-lines'), 10) || 0;
      return Math.max(declared, shown ? shown + 1 : 0);
    }

    function fitOne(el) {
      // A zero width means it is not laid out yet; measuring now would drive
      // the size to the floor.
      if (!el.clientWidth) return;

      // Restore the AUTHORED size so a widening viewport can grow the text back.
      //
      // This has to remember the value rather than clear the property: both
      // headings declare `font-size: clamp(26px, 3vw, 40px)` in the same inline
      // style attribute this writes to, so `el.style.fontSize = ''` deleted the
      // design's own size and left the heading on the UA default — 24px at 1440
      // against a 40px design, 20px on a phone against 26px. Nothing in the
      // stylesheet sizes these two headings, so there was no floor to land on.
      if (el._lunaBaseFs === undefined) el._lunaBaseFs = el.style.fontSize;
      el.style.fontSize = el._lunaBaseFs;

      var maxLines = targetLines(el);
      if (!maxLines) return;

      var cs = window.getComputedStyle(el);
      var base = parseFloat(cs.fontSize);

      // The floor has to leave room to move. Both headings are
      // `clamp(26px, 3vw, 40px)`, so below about 867px the clamp already sits
      // ON the old flat 26px floor and `size > MIN` was false before the first
      // step — the fitter had a target it could never work towards. Sizing the
      // floor off the heading's own resolved size instead means there is always
      // headroom: 26px on desktop exactly as before, ~22px on a phone.
      var floor = Math.max(ABS_MIN, Math.min(SOFT_MIN, base * 0.85));
      var size = base;

      function lines() {
        var c = window.getComputedStyle(el);
        var lh = parseFloat(c.lineHeight);
        if (!lh) lh = parseFloat(c.fontSize) * 1.2;
        return Math.round(el.getBoundingClientRect().height / lh);
      }

      while (size - STEP >= floor && lines() > maxLines) {
        size -= STEP;
        el.style.fontSize = size + 'px';
      }

      // Shrinking only earns its keep if it actually got there. On a narrow
      // phone these headings are 60-70 characters and cannot reach two lines at
      // any size worth reading, so the loop would otherwise bottom out and ship
      // a heading that is BOTH smaller and still three lines. Put the design's
      // own size back and let it wrap, which is what the mocks do there.
      if (lines() > maxLines) el.style.fontSize = el._lunaBaseFs;
    }

    function fitAll() { els.forEach(fitOne); }

    // Now, after layout settles, and again once the webfont swaps in — each of
    // those changes the measurement.
    fitAll();
    requestAnimationFrame(fitAll);
    window.addEventListener('load', fitAll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);

    var t;
    function refit() { clearTimeout(t); t = setTimeout(fitAll, 150); }
    window.addEventListener('resize', refit, { passive: true });
    if (window.ResizeObserver) els.forEach(function (el) { new ResizeObserver(refit).observe(el); });
  })();

  /* -------------------------------------------------------------------------
     Backed by Experts scroller dots (mobile)
     -------------------------------------------------------------------------
     The row is a native scroll-snap scroller, so the active card is simply the
     one nearest the scroll offset. Dots are hidden above the phone breakpoint,
     where the row is a grid and nothing scrolls.
     ------------------------------------------------------------------------- */
  (function () {
    var row = $('[data-luna-experts-row]') || $('.luna__experts-row');
    var dotsEl = $('[data-luna-experts-dots]');
    if (!row || !dotsEl) return;
    var dots = Array.prototype.slice.call(dotsEl.children);
    if (!dots.length) return;

    var raf = null;
    function paint() {
      raf = null;
      var cards = row.children;
      if (!cards.length) return;
      var step = cards[0].getBoundingClientRect().width + 10; // gap: 10px
      var i = Math.round(row.scrollLeft / step);
      if (i < 0) i = 0;
      if (i > dots.length - 1) i = dots.length - 1;
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }

    row.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(paint);
    }, { passive: true });

    // The mock's dots are indicators only; making them press targets costs one
    // listener and is what anyone tapping them expects.
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () {
        var cards = row.children;
        if (!cards.length) return;
        var step = cards[0].getBoundingClientRect().width + 10;
        row.scrollTo({ left: n * step, behavior: 'smooth' });
      });
    });

    paint();
  })();

  /* -------------------------------------------------------------------------
     Review carousel
     -------------------------------------------------------------------------
     The same Swiper the 005 transformations section uses, ported rather than
     loading reformly-005-sections.js — that file boots every [data-r5-swiper]
     on the page and owns other 005 behaviours this page has no use for.

     slidesPerView 'auto' leaves the widths to CSS; autoplay pauses on a swipe
     rather than stopping, and loops so the arrows never dead-end.
     ------------------------------------------------------------------------- */
  (function () {
    var rails = $$('[data-r5-swiper]');
    if (!rails.length) return;

    function boot(rail) {
      var scope = rail.closest('[data-r5-carousel]') || rail.parentElement;
      var conf = function (name, dflt) {
        var v = (scope && scope.getAttribute(name)) || rail.getAttribute(name);
        return v == null ? dflt : v;
      };
      var autoMs = parseInt(conf('data-r5-auto', 0), 10) || 0;
      var gap = parseInt(conf('data-r5-gap', 0), 10) || 0;
      // The mock uses a tighter gap at one-card-per-view; spaceBetween cannot
      // be a media query, so it moves at the same 900px Swiper breakpoint the
      // widths do.
      var gapSm = parseInt(conf('data-r5-gap-sm', gap), 10) || gap;
      var prevEl = scope ? scope.querySelector('[data-r5-prev]') : null;
      var nextEl = scope ? scope.querySelector('[data-r5-next]') : null;

      // data-r5-per="1.22,2,3" hands Swiper the per-view counts for
      // <900 / <1200 / above. It then computes slide widths and the snap step
      // in whole pixels itself.
      //
      // Percentage widths in CSS cannot do this under `loop`: Swiper clones the
      // slides and resizes the wrapper, so an 82% width resolves against a box
      // it is also changing and the step lands a few percent short — which is
      // the sliver of the outgoing card left on screen. The CSS widths stay as
      // the pre-init fallback (a numeric slidesPerView that never boots would
      // otherwise leave every slide at Swiper's default 100%).
      // Tokens may be a number or the word "auto". Numeric hands Swiper the
      // sizing; "auto" leaves it to the CSS widths. Mobile needs numeric — under
      // `loop` Swiper clones slides and resizes the wrapper, so a percentage
      // width resolves against a box it is also changing and the snap step
      // lands short, leaving a sliver of the outgoing card. Desktop has no such
      // problem and is safer on CSS, which is also correct before Swiper boots.
      var per = (conf('data-r5-per', '') || '').split(',').map(function (t) {
        t = (t || '').trim();
        return t === 'auto' ? 'auto' : parseFloat(t);
      });
      var hasPer = per.length === 3 && per[0] !== '' && !(typeof per[0] === 'number' && isNaN(per[0]));
      function pv(i) { return hasPer ? per[i] : 'auto'; }
      // Each rail switches at its own widths — the reviews at 900/1200, the
      // bestsellers at 700/1100 — so the breakpoints travel with the per-view
      // counts instead of being fixed here.
      var bp = (conf('data-r5-bp', '900,1200') || '').split(',').map(function (n) { return parseInt(n, 10); });

      var cfg = {
        slidesPerView: pv(0),
        spaceBetween: gapSm,
        // Only the full-bleed rail centres its card; above 900px it goes flush left.
        centeredSlides: rail.hasAttribute('data-r5-bleed'),
        speed: 700,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {}
      };
      cfg.breakpoints[bp[0]] = {
        centeredSlides: false,
        spaceBetween: gap,
        slidesPerView: pv(1)
      };
      cfg.breakpoints[bp[1]] = {
        centeredSlides: false,
        spaceBetween: gap,
        slidesPerView: pv(2)
      };
      if (autoMs) {
        // disableOnInteraction:false — a swipe pauses autoplay, it does not kill it
        cfg.autoplay = { delay: autoMs, disableOnInteraction: false, pauseOnMouseEnter: true };
        // `loop`, not `rewind`. Without clones Swiper clamps the track at the
        // end so the LAST card sits flush right — which leaves the one before
        // it hanging in the left edge. Looping keeps slides on both sides, so
        // the track never clamps and the outgoing card always clears.
        cfg.loop = true;
      }
      if (prevEl && nextEl) cfg.navigation = { prevEl: prevEl, nextEl: nextEl };

      // A draggable scrollbar where the rail ships one — the bestsellers rail
      // has no arrows, so this is its only affordance besides dragging.
      var bar = scope ? scope.querySelector('.swiper-scrollbar') : null;
      if (bar) cfg.scrollbar = { el: bar, draggable: true };

      new Swiper(rail, cfg);
    }

    function bootAll() { rails.forEach(boot); }

    if (window.Swiper) { bootAll(); return; }
    var waited = 0;
    var poll = setInterval(function () {
      if (window.Swiper) { clearInterval(poll); bootAll(); }
      else if ((waited += 50) > 5000) clearInterval(poll);
    }, 50);
  })();

  /* -------------------------------------------------------------------------
     Bestsellers rail — card interactions
     -------------------------------------------------------------------------
     Swiper owns the dragging and the progress bar now (data-r5-swiper), so all
     that is left here is routing a press: a swatch swaps the card's photo, a
     press anywhere else opens the cart drawer's quick view. Swiper's own
     preventClicks suppresses the click that ends a drag, which is what the
     hand-rolled version needed its own movement threshold for.
     ------------------------------------------------------------------------- */
  (function () {
    var rail = $('[data-luna-rail]') || $('.luna__rail');
    if (!rail) return;

    function selectSwatch(sw) {
      var card = sw.closest('[data-luna-quick]');
      if (!card) return;

      var img = sw.getAttribute('data-img');
      var imgEl = card.querySelector('.luna__card-img');
      if (img && imgEl && imgEl.getAttribute('src') !== img) {
        // image_tag emits a srcset, and a srcset outranks src — swapping src
        // alone left the browser still painting the original candidate.
        imgEl.removeAttribute('srcset');
        imgEl.removeAttribute('sizes');
        imgEl.src = img;
      }

      var vid = sw.getAttribute('data-variant');
      if (vid) {
        var href = card.getAttribute('href') || '';
        card.setAttribute('href', href.split('?')[0] + '?variant=' + vid);
      }

      card.querySelectorAll('[data-luna-swatch]').forEach(function (o) {
        o.classList.toggle('is-active', o === sw);
      });
    }

    rail.addEventListener('click', function (e) {
      var sw = e.target.closest && e.target.closest('[data-luna-swatch]');
      if (sw) {
        e.preventDefault();
        e.stopPropagation();
        selectSwatch(sw);
        return;
      }

      var card = e.target.closest && e.target.closest('[data-luna-quick]');
      if (!card) return;
      if (!window.rypCart || typeof window.rypCart.quickView !== 'function') return;
      if (!document.getElementById('ryp-quick')) return;

      e.preventDefault();
      var handle = card.getAttribute('data-luna-quick');
      window.rypCart.quickView(handle);
      ph('reformly_plus_quick_view', { handle: handle });
    }, true);

    // role=button, so it has to answer Enter and Space like one.
    rail.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var sw = e.target.closest('[data-luna-swatch]');
      if (!sw) return;
      e.preventDefault();
      selectSwatch(sw);
    });
  })();
})();
